import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'

import { MembershipGroupUpdateParamsSchemas } from 'schemas/membershipsSchemas'
import { MembershipGroupUpdateParamsTypes } from 'types/memberships'

export const useMemberMembershipGroupUpdateForm = ({
  defaultValues,
}: {
  defaultValues: MembershipGroupUpdateParamsTypes
}) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    watch,
  } = useForm<MembershipGroupUpdateParamsTypes>({
    resolver: zodResolver(MembershipGroupUpdateParamsSchemas),
    defaultValues,
  })

  return {
    handleSubmit,
    control,
    errors,
    setValue,
    reset,
    watch,
  }
}
